<app-page-header title="Sales Performance Report" subtitle="Track sales metrics and year-over-year comparisons"></app-page-header>

<div class="sales-report-container">
    <!-- Summary Cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <p-card styleClass="summary-card">
            <div class="summary-content">
                <div class="summary-icon revenue">
                    <i class="pi pi-dollar text-xl"></i>
                </div>
                <div class="summary-details">
                    <span class="summary-label">Total Revenue</span>
                    <span class="summary-value">{{
                        salesPerformanceData()?.thisYear?.rangedRevenue?.amount
                            | currency: salesPerformanceData()?.thisYear?.rangedRevenue?.currency
                    }}</span>
                </div>
            </div>
        </p-card>

        <p-card styleClass="summary-card">
            <div class="summary-content">
                <div class="summary-icon reservation">
                    <i class="pi pi-ticket text-xl"></i>
                </div>
                <div class="summary-details">
                    <span class="summary-label">Total Reservation</span>
                    <span class="summary-value">{{ salesPerformanceData()?.thisYear?.ranged?.reservation ?? 0 }}</span>
                </div>
            </div>
        </p-card>

        <p-card styleClass="summary-card">
            <div class="summary-content">
                <div class="summary-icon cancel">
                    <i class="pi pi-times-circle text-xl"></i>
                </div>
                <div class="summary-details">
                    <span class="summary-label">Total Cancel</span>
                    <span class="summary-value">{{ salesPerformanceData()?.thisYear?.ranged?.cancel ?? 0 }}</span>
                </div>
            </div>
        </p-card>

        <p-card styleClass="summary-card">
            <div class="summary-content">
                <div class="summary-icon seat">
                    <i class="pi pi-users text-xl"></i>
                </div>
                <div class="summary-details">
                    <span class="summary-label">Total Seat</span>
                    <span class="summary-value">{{ salesPerformanceData()?.thisYear?.ranged?.seat ?? 0 }}</span>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Year-over-Year Comparison -->
    <p-card header="Last Year Comparison" styleClass="comparison-section-card">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="comparison-item">
                <span class="comparison-title">Last Year Total Reservation</span>
                <div class="comparison-values">
                    <span class="comparison-base">{{ salesPerformanceData()?.lastYearReservation ?? 0 }}</span>
                    <div
                        class="comparison-indicator"
                        [class]="comparisonClassControl(salesPerformanceData()?.comparisonReservation?.status)"
                    >
                        @if (salesPerformanceData()?.comparisonReservation?.status == 'UP') {
                            <i class="pi pi-arrow-up"></i>
                        } @else if (salesPerformanceData()?.comparisonReservation?.status == 'DOWN') {
                            <i class="pi pi-arrow-down"></i>
                        }
                        <span>{{ salesPerformanceData()?.comparisonReservation?.value ?? 0 }}%</span>
                    </div>
                </div>
                <span class="comparison-note">vs last year</span>
            </div>

            <div class="comparison-item">
                <span class="comparison-title">Last Year Total Seat</span>
                <div class="comparison-values">
                    <span class="comparison-base">{{ salesPerformanceData()?.lastYearSeat ?? 0 }}</span>
                    <div class="comparison-indicator" [class]="comparisonClassControl(salesPerformanceData()?.comparisonSeat?.status)">
                        @if (salesPerformanceData()?.comparisonSeat?.status == 'UP') {
                            <i class="pi pi-arrow-up"></i>
                        } @else if (salesPerformanceData()?.comparisonSeat?.status == 'DOWN') {
                            <i class="pi pi-arrow-down"></i>
                        }
                        <span>{{ salesPerformanceData()?.comparisonSeat?.value ?? 0 }}%</span>
                    </div>
                </div>
                <span class="comparison-note">vs last year</span>
            </div>
        </div>
    </p-card>

    <!-- Chart & Table Section -->
    <p-card header="Monthly Sales Numbers" styleClass="chart-table-card">
        <div class="flex flex-col gap-6">
            <p-chart type="line" [data]="chartData()" [options]="chartOptions" height="300px"></p-chart>
            <app-table-component
                [cols]="cols"
                [data]="tableData() || []"
                [loading]="loading()"
                [pagination]="false"
                [oddRowColor]="'#ffffff'"
                [evenRowColor]="'#f8fafc'"
            />
        </div>
    </p-card>
</div>
